export { ConnectProviderSlide } from './ConnectProviderSlide';
export {
  type ConnectAccountingProviderSlideProps,
  type ConnectPayrollProviderSlideProps,
  type ConnectTicketingProviderSlideProps,
  ConnectProviderStatus,
} from './slides';
